import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Towel.svg",
  "use": "Towel.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Towel.svg\"><path d=\"M55.5,19h-5a.5.5,0,0,1-.5-.5v-4a.5.5,0,0,1,.5-.5h5a2.5,2.5,0,1,1,0,5ZM46,54H18a2,2,0,0,1-2-2V46.5a.5.5,0,0,1,.5-.5h31a.5.5,0,0,1,.5.5V52A2,2,0,0,1,46,54Zm1.5-10h-31a.5.5,0,0,1-.5-.5V14a4,4,0,0,1,4-4H44a4,4,0,0,1,4,4V43.5A.5.5,0,0,1,47.5,44Zm-34-25h-5a2.5,2.5,0,0,1,0-5h5a.5.5,0,0,1,.5.5v4A.5.5,0,0,1,13.5,19Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol